import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type CaseFlexBase from "@/components/CaseFlex.Base.vue";

export default defineMosaicComponent<typeof CaseFlexBase>("components/CaseFlex");
